import { api, baseUrl } from "../../api";

export const getLocationTrackerData = async (params?: any) => {
  const res = await api.get(`${baseUrl}/driver/location-tracker`, { params });
  return res.data;
};